'kiwi public';

import _Object$assign from "@babel/runtime-corejs3/core-js-stable/object/assign";
import _ from 'lodash';
var isEnabled = false;
export function requestPermission(state) {
  // Do we support notifications?
  if (!('Notification' in window)) {
    isEnabled = false;
    return;
  }

  // Permissions already been granted?
  if (Notification.permission === 'granted') {
    state.$emit('notification.enabled');
    isEnabled = true;
    return;
  }
  if (Notification.permission !== 'denied') {
    Notification.requestPermission(function (permission) {
      if (permission === 'granted') {
        state.$emit('notification.enabled');
        isEnabled = true;
      } else {
        isEnabled = false;
      }
    });
  }
}
export function show(title, body, opts) {
  if (!isEnabled) {
    return false;
  }
  var notify = new Notification(title, {
    body: body,
    icon: opts.icon
  });
  if (opts.ttl) {
    setTimeout(notify.close.bind(notify), opts.ttl);
  }
  return notify;
}
var throttledShow = _.throttle(show, 2000);
export function listenForNewMessages(state) {
  state.$on('notification.show', function (message, _opts) {
    if (!isEnabled) {
      return;
    }
    var opts = _Object$assign({
      title: 'Kiwi IRC',
      message: message,
      icon: '',
      onclick: null,
      ttl: 10000
    }, _opts);
    if (!opts.message) {
      return;
    }
    var notification = throttledShow(opts.title, opts.message, {
      ttl: opts.ttl
    });
    if (notification && typeof opts.onclick === 'function') {
      notification.onclick = opts.onclick;
    }
  });
}
window._kiwi_exports = window._kiwi_exports || {};
if(!window._kiwi_exports["libs"]) window._kiwi_exports["libs"] = {};
window._kiwi_exports["libs"]["Notifications"]
window._kiwi_exports.libs.Notifications = (typeof exports !== 'undefined' ? (exports.default || exports) : (typeof module !== 'undefined' && module.exports ? (module.exports.default || module.exports) : {}));
